import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { GridBackground, Logo, Spinner } from './UI';
import { inputStyle, btnPrimary, colors, fonts } from '../lib/styles';

export default function AuthPage({ onAuth }) {
  const [mode, setMode] = useState('login'); // 'login' | 'signup'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [handle, setHandle] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    setError(''); setSuccess('');
    if (!email || !password) return setError('Email and password required.');
    if (mode === 'signup' && !handle) return setError('Handle required.');
    if (password.length < 6) return setError('Password must be at least 6 characters.');

    setLoading(true);
    try {
      if (mode === 'signup') {
        const { data, error: signUpError } = await supabase.auth.signUp({
          email, password,
          options: { data: { handle } },
        });
        if (signUpError) throw signUpError;
        // Insert profile row
        if (data.user) {
          await supabase.from('profiles').insert({
            id: data.user.id,
            handle,
            email,
          });
        }
        setSuccess('Account created! Check your email to confirm, then log in.');
        setMode('login');
      } else {
        const { data, error: loginError } = await supabase.auth.signInWithPassword({ email, password });
        if (loginError) throw loginError;
        onAuth(data.user);
      }
    } catch (err) {
      setError(err.message || 'Something went wrong.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: colors.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', position: 'relative' }}>
      <GridBackground />
      <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: '400px', animation: 'fadeIn 0.3s ease' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <Logo size="lg" />
          <p style={{ fontFamily: fonts.mono, fontSize: '11px', color: colors.textDim, marginTop: '16px', letterSpacing: '0.15em' }}>
            {mode === 'login' ? 'ACCESS THE GRID' : 'JOIN THE NETWORK'}
          </p>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.02)', border: '1px solid #00ffc820',
          borderRadius: '6px', padding: '32px',
          boxShadow: '0 0 40px rgba(0,255,200,0.05)',
        }}>
          {/* Mode toggle */}
          <div style={{ display: 'flex', marginBottom: '24px', border: '1px solid #ffffff10', borderRadius: '3px', overflow: 'hidden' }}>
            {['login', 'signup'].map(m => (
              <button key={m} onClick={() => { setMode(m); setError(''); setSuccess(''); }} style={{
                flex: 1, padding: '9px',
                fontFamily: fonts.display, fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em',
                background: mode === m ? colors.cyan : 'transparent',
                color: mode === m ? '#000' : colors.textDim,
                border: 'none', cursor: 'pointer', transition: 'all 0.2s',
                textTransform: 'uppercase',
              }}>{m === 'login' ? 'LOG IN' : 'SIGN UP'}</button>
            ))}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {mode === 'signup' && (
              <div>
                <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>
                  YOUR HANDLE
                </label>
                <input value={handle} onChange={e => setHandle(e.target.value.toLowerCase().replace(/\s/g, '_'))}
                  placeholder="grid_operator" style={inputStyle} />
              </div>
            )}
            <div>
              <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>
                EMAIL
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@domain.com" style={inputStyle}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
            </div>
            <div>
              <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>
                PASSWORD
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" style={inputStyle}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
            </div>
          </div>

          {error && (
            <div style={{ marginTop: '14px', padding: '10px 14px', background: 'rgba(255,60,110,0.08)', border: '1px solid #ff3c6e30', borderRadius: '3px' }}>
              <p style={{ fontFamily: fonts.mono, fontSize: '12px', color: colors.red, margin: 0 }}>{error}</p>
            </div>
          )}
          {success && (
            <div style={{ marginTop: '14px', padding: '10px 14px', background: 'rgba(0,255,200,0.06)', border: '1px solid #00ffc830', borderRadius: '3px' }}>
              <p style={{ fontFamily: fonts.mono, fontSize: '12px', color: colors.cyan, margin: 0 }}>{success}</p>
            </div>
          )}

          <button onClick={handleSubmit} disabled={loading} style={{ ...btnPrimary(loading), width: '100%', marginTop: '20px', padding: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
            {loading ? <Spinner size={16} color="#000" /> : null}
            {loading ? 'CONNECTING...' : mode === 'login' ? 'ACCESS GRID' : 'JOIN NETWORK'}
          </button>
        </div>
      </div>
    </div>
  );
}
